"use client"

import { useEffect } from 'react'

export default function PwaInit() {
  useEffect(() => {
    if (typeof window === 'undefined') return
    if ('serviceWorker' in navigator) {
      const swUrl = '/sw.js'
      navigator.serviceWorker
        .register(swUrl)
        .catch((err) => {
          console.error('SW registration failed:', err)
        })
    }
  }, [])

  return null
}
